
import { Outlet } from 'react-router-dom';
import NerisSettingsNav from '../../components/HeadersNav/NerisSettingsNav';

const NerisSettingsPage = () => {
  return (
    <>
      <NerisSettingsNav />
      <Outlet />
    </>
  );
};

export default NerisSettingsPage;
